module.exports = __webpack_public_path__ + "static/media/Location_Book-Page29.370f237b.png";